export default function PCEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/pc/Comprehensive-Plan-Update-2021.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Comprehensive Plan Update - 2021
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/pc/Comprehensive-Plan-2008.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Comprehensive Plan - 2008
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/pc/What-Constitutes-Blight.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; What Constitutes Blight?
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
